const single_sign_on = {
    forbidden_domains: 'Nie są dozwolone publiczne domeny e-mail.',
    duplicated_domains: 'Istnieją zduplikowane domeny.',
    invalid_domain_format: 'Nieprawidłowy format domeny.',
    duplicate_connector_name: 'Nazwa łącznika już istnieje. Proszę wybrać inną nazwę.',
};
export default Object.freeze(single_sign_on);
